import * as types from '../types/table';

const initialState = {
    editTable: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SET_EDIT_TABLE:
            return {
                ...state,
                editTable: action.payload,
            };
        default:
            return state;
    }
};
